import Vue from 'vue';
import Router from 'vue-router';

import Login from './views/Login.vue';
import DashView from './views/DashView';
import DashboardHome from './views/children/DashboardHome';
import InstanceManagement from './views/children/InstanceManagement';
import ChannelSettingsOverview from './views/children/channel/settings/ChannelSettingsOverview';
import AdminLogs from './views/children/admin/AdminLogs';

/**
 * Middlewares
 */
import auth from './middleware/auth';
import admin from './middleware/admin';
import instanceloaded from './middleware/instanceloaded';
import instanceNotLoaded from './middleware/instanceNotLoaded';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { title: 'Smart Media - Login' },
    },
    {
      path: '/',
      component: DashView,
      name: 'DashView',
      children: [
        {
          path: 'home',
          name: 'home',
          component: DashboardHome,
          meta: { middleware: [auth, instanceNotLoaded], title: 'Smart Media - Dashboard' },
        },
        {
          path: 'manage',
          name: 'InstanceManagement',
          component: InstanceManagement,
          meta: { middleware: [auth, instanceloaded], title: 'Smart Media - Management' },
        },
        {
          path: 'channel/settings',
          name: 'channel-settings',
          component: ChannelSettingsOverview,
          meta: { middleware: auth, title: 'Smart Media - Channel Settings' },
        },
        {
          path: 'admin/logs',
          name: 'admin-logs',
          component: AdminLogs,
          meta: { middleware: [auth, admin], title: 'Smart Media - Admin Logs' },
        },
      ],
    },
  ],
});

/**
 * Vue Router Middleware System
 */

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

export default router;
